import { useState, useEffect, forwardRef } from "react"
import './index.scss';

type Props = {

};
const Head = forwardRef((props: Props, ref) => {
    const [date, setDate] = useState({ date: '', time: '', week: '' });

    // 时间
    useEffect(() => {
        let timer;
        let date = new Date(),
            year: any = date.getFullYear(),//获取当前年份   
            mon: any = date.getMonth() + 1,//获取当前月份   
            da: any = date.getDate(),//获取当前日 
            week: any = "日一二三四五六".charAt(date.getDay()),
            h: any = date.getHours(),//获取小时   
            m: any = date.getMinutes(),//获取分钟   
            s: any = date.getSeconds();//获取秒   
        if (mon < 10) mon = "0" + mon;
        if (da < 10) da = "0" + da;
        if (s < 10) s = "0" + s;
        if (h < 10) h = "0" + h;
        if (m < 10) m = "0" + m;
        timer = setInterval(() => {
            setDate({
                date: `${year}/${mon}/${da}`,
                time: `${h}:${m}:${s}`,
                week: `星期${week}`,
            })
        }, 1000)
        return () => {
            clearInterval(timer)
        }
    }, [date])

    return (
        <div className="head">
            <div className="value date">{date.date}</div>
            <div className="value time">{date.time}</div>
            <div className="value week">{date.week}</div>
        </div>
    )
})
export default Head